import './CRUD.scss';
import Component from './CRUD.js';
export default Component;
